export const mhCounselor = {
  counselor: 'Ratgeber',
  return: 'Zurück',
  learn: 'Lernen Sie über aktuellen Themen rund um das Thema Haus und Renovationen.',
  presented: 'Vorgestellt',
  newArticle: 'Neue Artikel',
  allTopics: 'Alle Themen',
  topic: 'THEMA',
  extendMortgage: 'Hypothekverlängerung',
  mortgageText:
    'Läuft ein Hypothekarvertrag aus, steht die Verlängerung der Finanzierung an. Die Wahl der richtigen Strategie ist einerseits abhängig von Ihren individuellen Bedürfnissen, andererseits von der allgemein prognostizierten Zinsentwicklung und der eigenen Einschätzung. Mit diesen fünf Tipps von MoneyPark gelingt die Anschlussfinanzierung Ihrer Hypothek.',
  taxSaving: 'Steuerabzüge bei Sanierungen',
  taxSavingText:
    'Für Hausbesitzer gelten ab 1. Januar 2020 neue Regeln bei den Abzügen der direkten Bundessteuer. Neu können energiesparende und umweltschonende Invest…',
  removal: 'Abschaffung Libor',
  removalText:
    'Die Libor-Hypothek ist trotz des tiefen Zinsniveaus nach wie vor beliebt. Ende 2021 wird der ihr zugrunde liegende Libor-Satz jedoch abgeschafft, und …',
  renovation: 'Renovation und Finanzierung',
  renovationText:
    'Sie besitzen ein Eigenheim und es stehen einige Renovationen an? Fehlen Ihnen dazu aktuell die finanziellen Mittel, kommen verschiedene Finanzierungsm…',
  kitchen: 'Ratgeber neue Küche',
  kitchenText:
    'Ihre neue Küche ist eine langfristige Investition. Der Qualität der Ausführung kommt daher besondere Bedeutung zu. Die Gesamtkosten über die Lebensdau…',
  energeticRenovation: 'Ratgeber Energetisch Sanieren',
  energeticRenovationText:
    'Vor der energetischen Sanierung des Gebäudes sollten Sie Ihr Gebäude beurteilen lassen und eine Strategie wählen. Wichtig ist es, den Energieverbrauch…',
  energySaving: 'Energiespartipps',
  energySavingText:
    'Mit den folgenden Tipps gelingt es Ihnen, den Energieverbrauch erheblich zu reduzieren. Jetzt mehr erfahren.',
  counseling: 'Beratung',
  counselingText:
    'Gebäudehülle, Heizung und Wassererwärmung bestimmen die energetische Qualität eines Gebäudes wesentlich. Lassen Sie sich frühzeitig beraten.',
  isolation: 'Dämmung Gebäudehülle',
  isolationText:
    'Eine zeitgemässe Dämmung sorgt für ein ausgeglichenes Raumklima im Winter wie im Sommer und spart Energie.',
  heatPump: 'Wärmepumpe',
  heatPumpText:
    'Ein Heizungsersatz bietet Ihnen die Chance, vermehrt erneuerbare Energien für die Heizung und das Warmwasser zu nutzen. Wärmepumpen bieten genau dies …',
  solarThermal: 'Solarthermie',
  solarThermalText:
    'Eine thermische Solaranlage fängt die Wärme der Sonne mit Kollektoren ein und liefert warmes Wasser für Küche und Bad. Mit etwas grösserer Fläche unte…',
  photovoltaicSystem: 'Photovoltaikanlagen',
  photovoltaicSystemText:
    'Eine Photovoltaik Anlage liefert erneuerbaren Strom am eigenen Gebäude. Solarzellen produzieren heute nicht mehr nur auf Dachflächen, sondern auch an …',
}
